module.exports = __webpack_public_path__ + "logo.4dea9e362f1aefba586bbd002d1ebc19.png";